import { PUBLIC_URL } from "@/config/env";

const publicPath = (path: string): string => {
  return `${PUBLIC_URL}${path}`;
};

export default publicPath;
